import styled from 'styled-components';

export const FormContainer = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  margin-top: 20px;
  width: 100%;
`;

export const Header = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodyLargeSemibold}
`;

export const Description = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  color: ${(props) => props.theme.newPalette.neutral.N600};
  padding-bottom: 20px;
`;
